import React, {useState} from 'react';
import {Backdrop} from '@material-ui/core';
import classNames from 'classnames';
import ellipsisSvg from '../images/ellipsis.svg';

const SnapshotAndDataExportDropdown = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      {isOpen && (
        <Backdrop
          className="bentobox-popover-backdrop"
          open={isOpen}
          onClick={() => {
            setIsOpen(false);
          }}
        />
      )}
      <div className={classNames('dropdown', {isOpen})}>
        <img
          className="more-button"
          src={`${window.NationalInstruments.bentoBox.svgSpriteUrl}${ellipsisSvg.id}`}
          onClick={() => setIsOpen(true)}
        />
        <div className="dropdown-content">{props.children}</div>
      </div>
    </>
  );
};

export default SnapshotAndDataExportDropdown;
